<template>
  <div class="card floating" id="cancel-subscription">
    <h2>{{ $t('prompts.likingIberbox') }}</h2>
    <p v-html="$t('prompts.expiredSubscription')"></p>
    <div class="contenedor-opciones">
      <div style="position: relative; padding: 0; width: 69%;">
        <div class="campo">
          <p>{{ planSelected }}</p>
          <chevron-down-icon size="1.5x" class="chevron" @click="isShowPlan = !isShowPlan"></chevron-down-icon>
        </div>
        <nav id="menu-desplegable" :style="planStyle">
          <div style="display: block; border: none; text-align: left;">
            <button v-for="(plan) in plans" :key="plan" :title="plan" :aria-label="plan" @click="cambioPlan(plan)" type="button">
              <p>{{ plan }}</p>
            </button>
          </div>
        </nav>
      </div>
      <div style="position: relative; padding: 0; width: 27%;">
        <div class="campo">
          <p>{{ storageSelected }}</p>
        </div>
      </div>
    </div>
    <div class="botones">
      <button @click="cancelSubscription()" :aria-label="$t('prompts.cancelAccount')" :title="$t('prompts.cancelAccount')" id="choose-plan-button">
        <span>{{ $t('prompts.cancelAccount') }}</span>
      </button>
      <div style="display: flex; align-items: center;">
        <div class="precio">
          <p>{{ precio }}{{ $t('login.€/year') }}</p>
        </div>
        <button @click="selectPlan()" :aria-label="$t('prompts.selectPlan')" :title="$t('prompts.selectPlan')" id="select-plan-button">
          <span>{{ $t('prompts.selectPlan') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { ChevronDownIcon } from 'vue-feather-icons';
import { files as api } from '@/api';
import i18n from '@/i18n';

export default {
  name: 'change-plan',
  components: {
    ChevronDownIcon
  },
  data: function () {
    return {
      tarifas: [],
      planSelected: '',
      isShowPlan: false,
      plans: [],
      storages: '',
      storageSelected: '',
      precio: 0,
      mapaPlanes: ''
    };
  },
  async mounted () {
    this.mapaPlanes = new Map();

    try {
      let action = await api.getSubscriptionOptionsWithFeatures(15);
      this.tarifas = action.filter(({period}) => period == 2)
            .map(t => ({...t, amount: t.amount / 100.0, discount: t.discount / 100.0}))
            .sort((a, b) => a.storage - b.storage);
      for (let i = 0; i < this.tarifas.length; i++) {
        let storagesPlan;
        let temp;
        temp = this.tarifas[i].name.split('(');
        storagesPlan = temp[1].replace(')', '');

        if (!this.plans.includes(temp[0])) {
          this.plans.push(this.tarifas[i].name);
        }

        this.mapaPlanes.set(this.plans[i], storagesPlan);
      }
    } catch (e) {
      this.$showError(e);
    }

    try {
      let action = await api.getSubscriptionOptions();
      let temp;
      temp = action[0].name.split('(');
      this.planSelected = action[0].name;
      this.storageSelected = temp[1].replace(')', '');
      this.precio = (1.21 * ((action[0].amount/100.0) - (action[0].discount/100.0))).toFixed(2);
    } catch (e) {
      this.$showError(e);
    }
  },
  watch: {
    planSelected (val) {
      this.storages = this.mapaPlanes.get(val);
      this.storageSelected = this.mapaPlanes.get(val);
    }
  },
  computed: {
    planStyle () {
      if (this.isShowPlan) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
  },
  methods: {
    ...mapMutations(['closeHovers']),
    cambioPlan (plan) {
      this.planSelected = plan;
      this.isShowPlan = false;
      this.storages = this.mapaPlanes.get(this.planSelected);
      this.storageSelected = this.mapaPlanes.get(this.planSelected);
      this.cambiarPrecio();
    },
    cambioStorage (storage) {
      this.storageSelected = storage;
      this.cambiarPrecio();
    },
    cambiarPrecio() {
      for (let tarifa of this.tarifas) {
        if (tarifa.name.includes(this.planSelected) && tarifa.name.includes(this.storageSelected)) {
          this.precio = (1.21 * (tarifa.amount - tarifa.discount)).toFixed(2);
        }
      }
    },
    cancelSubscription() {
      this.$store.commit('closeHovers');
      this.$store.commit('showHover', 'cancel-subscription');
    },
    async selectPlan() {
      for (let tarifa of this.tarifas) {
        if (tarifa.name.includes(this.planSelected) && tarifa.name.includes(this.storageSelected)) {
          let action = await ibb.setSubscription(tarifa.id);
          if (action.error.type) {
            throw new Error('Error setting subscription' + action.error.type);
          } else {
            this.$showSuccess(i18n.t('prompts.planSelectCorrectly'));
          }
        }
      }
      this.$store.commit('closeHovers');
    }
  }
};
</script>
